import type * as React from 'react';

import { TextButton } from '@xing-com/button';
import { IconLike, IconLikeFilled } from '@xing-com/icons';

export type LikeButtonProps = {
  hasLike: boolean;
  label: string | React.ReactNode;
  onClick: () => void;
  [props: string]: unknown;
};

export const LikeButton: React.FC<LikeButtonProps> = ({
  hasLike,
  label,
  onClick,
  ...props
}) => (
  <TextButton
    {...{ ...props, onClick }}
    icon={hasLike ? IconLikeFilled : IconLike}
  >
    {label}
  </TextButton>
);
